import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import './App.css';
import * as constants from './Constants';
import environment from './environments/environment';
import Pagination from './Pagination';
import PagerService from './Services/PagerService';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer,
    }
}

class LoginHistory extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            loginHistoryList: [],
            reDirect: '',
            id: 0,
            name: "",
            status: constants.IS_ACTIVE_YES,
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            //searchFlag: false,
            loginHistoryListCount: '',
            email: "",
            emailId: '',
            userRole: '',
            fromDate: new Date(),
            todate: new Date(),
            action: "",
            toDayDate: new Date(),
        }
        this.onRenderDayCell = this.onRenderDayCell.bind(this);
    }
    componentDidMount = async () => {
       // const timestamp = Date.now(); // This would be the timestamp you want to format
        if (this.props.userStatus.userName !== "") {
            this.setState({
                ...this.state,
                pageSize: this.toSetPagination(),
                emailId: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
            }, () => {
                this.setPage(1);
            })
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }
    onRenderDayCell(args) {
        if (this.state.toDayDate !== null) {
            if ((args.date > this.state.toDayDate)) {
                // sets isDisabled to true to disable the date.
                args.isDisabled = true;
            }
        }
    }
    onDateFocusOut(event) {
        if (event.target.value !== '') {
            let data = new Date(event.target.value);
            this.setState({
                ...this.state,
                [event.target.name]: data,
            })
        } else {
            this.setState({
                ...this.state,
                [event.target.name]: '',
            })
        }
    }
    changeValue = (e) => {
        if (e.target.name !== 'action') {
            this.setState({
                [e.target.name]: e.target.value
            });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            }, () => {
                this.setPage(1);
            })
        }
    }
    search = e => {
          e.preventDefault();
        this.setPage(1);
    };

    clear = e => {
        e.preventDefault();
        this.setState({
            name: '',
            email: "",
            fromDate: new Date(),
            todate: new Date(),
            action: ""
        }, () => {
            this.setPage(1);
        })
    }
    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.getLoginHistoryInfoList(page, this.state.pageSize);
    }
    getLoginHistoryInfoList(page, pageSize) {
        let loginHistorysearch = {};
        loginHistorysearch.name = this.state.name;
        loginHistorysearch.emailId = this.state.email;
        loginHistorysearch.action = this.state.action;
        loginHistorysearch.username = this.state.emailId;
        loginHistorysearch.fromDate = (this.state.fromDate !== null && this.state.fromDate !== '') ? Moment(this.state.fromDate).format('MM/DD/YYYY') : "";
        loginHistorysearch.todate = (this.state.todate !== null && this.state.todate !== '') ? Moment(this.state.todate).format('MM/DD/YYYY') : "";;
        loginHistorysearch.pageNo = -1;
        loginHistorysearch.pageSize = -1;
        axios.post(environment.getLoginHistorybyFilter, loginHistorysearch)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({ loginHistoryList: response.data.loginHistoryVOList }
                        , () => {
                            this.setState({
                                pageSize: this.toSetPagination(),
                                pager: PagerService.getPager(
                                    this.state.loginHistoryList.length,
                                    page,
                                    this.state.pageSize
                                ),
                                totalItems: this.state.loginHistoryList.length,
                                pagedItems: this.state.loginHistoryList.slice(
                                    (page - 1) * this.state.pageSize,
                                    page * this.state.pageSize
                                )
                            }, () => {
                            });
                        });
                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                }
            }
            )
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });

    }


    onRemindModal() {
        this.setState({ shows: false });
    };
    showRemindModal = (loginHistoryId) => {
        this.setState({
            loginHistoryId: loginHistoryId, shows: true
        });
    };
    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {
                        loginHistoryId: this.state.loginHistoryId,

                    }
                }} />
        }
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">

                    <h4>Login History</h4>
                    <div className="row mb15 mr-2" style={{ marginTop: ' 15px' }}>

                        <div className="col-4 pl-0 pr-0">
                            <label className="col-2  pl-0">Name </label>&nbsp;
                            <input type="text" id="name" name="name" placeholder="Name" value={this.state.name} onChange={this.changeValue}></input>

                        </div>

                        <div className="col-4 ">
                            <label className="col-2  pl-0">Email Id </label>&nbsp;
                            <input type="text" id="userID" name="email" placeholder="Email Id" value={this.state.email} onChange={this.changeValue}></input>

                        </div>

                        <div className="col-4 ">
                            <label className="col-2  pl-0">Action</label>&nbsp;
                            <select className="col-5" name="action" value={this.state.action} onChange={this.changeValue}  >
                                <option value='' >All</option>
                                <option value="Login">Login</option>
                                <option value="Logout">Logout</option>

                            </select>
                        </div>
                        <label style={{ width: '10%', paddingRight: '0%' }} className="mt-3"> From Date
                        </label>
                        <div style={{ width: '15%', paddingLeft: '1%', marginLeft: '-3%' }} className="mt-3">
                            <DatePickerComponent id="fromDate" name="fromDate" className="form-control" allowEdit={true} showTodayButton={false}
                                value={this.state.fromDate !== '' ? (Moment(this.state.fromDate).format('MM-DD-yyyy')) : (this.state.fromDate)} format='MM-dd-yyyy' onChange={this.changeValue}
                                renderDayCell={this.onRenderDayCell} onBlur={(event) => this.onDateFocusOut(event)}></DatePickerComponent>
                        </div>
                        <label style={{ width: '10%', marginLeft: '8%', paddingLeft: '4%', paddingRight: '0%' }} className="mt-3">To Date</label>
                        <div style={{ width: '15%', paddingLeft: '0px' }} className="mt-3">
                            <DatePickerComponent id="todate" name="todate" className="form-control" allowEdit={true} showTodayButton={false}
                                value={this.state.todate !== '' ? (Moment(this.state.todate).format('MM-DD-yyyy')) : (this.state.todate)} format='MM-dd-yyyy' onChange={this.changeValue}
                                renderDayCell={this.onRenderDayCell} onBlur={(event) => this.onDateFocusOut(event)}></DatePickerComponent>
                        </div>
                    </div>
                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                            <Link onClick={this.search}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Search</span></Link>
                            <Link onClick={this.clear}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Clear</span> </Link>
                        </div>
                    </div >
                    <div className="table-responsive dashboard ">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                            id="table-dashboard">

                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>

                                    <th >Name </th>
                                    <th >Email Id</th>
                                    <th >Action</th>
                                    <th style={{ textAlign: 'center' }}>Action Date</th>

                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.pagedItems != null && this.state.pagedItems.map((loginHistorys, index) => (
                                    <tr key={index}>
                                        <td>{loginHistorys.name}</td>
                                        <td  >{loginHistorys.emailId}</td>
                                        <td >{loginHistorys.action}</td>
                                        <td align="center">{Moment(loginHistorys.actionDate).format('MM/DD/YYYY hh:mm:ss A')}</td>
                                    </tr>
                                ))}

                            </tbody>

                        </table>
                    </div>

                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                    {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}

                    <ToastContainer style={{ marginTop: '7%' }} />



                </div >
            </section >



        )
    }

}
export default connect(mapStateToProps)(LoginHistory);